export default class GraphQlService {
  constructor() {
    this.version = "2023-01"; // storefront api version
    this.url = `//${window.location.host}/api/${this.version}/graphql.json`; // storefront api url
    this.apiToken = window.apiToken; // storefront api token
  }

  // Pass variables query to get data
  async use({ query, variables }, options) {
    try {
      const data = await fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          operationName: null,
          query,
          variables,
        }),
        headers: {
          "X-Shopify-Storefront-Access-Token": `${this.apiToken}`,
          "Content-Type": "application/json",
          ...options,
        },
        cache: "force-cache",
      }).then((res) => res.json());

      return data;
    } catch (error) {
      throw error;
    }
  }
}
